var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoAppartement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_appartement_-_biens_vendus",
    "data-name": "picto appartement - biens vendus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.889,
    height: 18.364,
    viewBox: "0 0 8.889 18.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_395",
    "data-name": "Trac\\xE9 395",
    d: "M8.791,4.3V.362A.352.352,0,0,0,8.456,0H.341A.352.352,0,0,0,0,.362V18a.352.352,0,0,0,.341.362H8.889ZM3.381,17.647V14.778H5.41v2.869Zm2.37-3.587H3.046a.351.351,0,0,0-.341.356v3.231H.676V.717H8.115v16.93H6.086V14.416a.346.346,0,0,0-.335-.356Z",
    transform: "translate(0 0)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_396",
    "data-name": "Trac\\xE9 396",
    d: "M7.172,3.7h.6a.3.3,0,0,0,.3-.3V2.8a.3.3,0,0,0-.3-.3h-.6a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,7.172,3.7Z",
    transform: "translate(-3.078 -1.3)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_397",
    "data-name": "Trac\\xE9 397",
    d: "M7.172,8.08h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3h-.6a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,7.172,8.08Z",
    transform: "translate(-3.078 -2.877)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_398",
    "data-name": "Trac\\xE9 398",
    d: "M7.172,12.45h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3h-.6a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,7.172,12.45Z",
    transform: "translate(-3.078 -4.704)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_399",
    "data-name": "Trac\\xE9 399",
    d: "M7.172,16.83h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3h-.6a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,7.172,16.83Z",
    transform: "translate(-3.078 -6.536)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_400",
    "data-name": "Trac\\xE9 400",
    d: "M7.172,21.2h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3h-.6a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,7.172,21.2Z",
    transform: "translate(-3.078 -8.363)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_401",
    "data-name": "Trac\\xE9 401",
    d: "M2.8,3.7h.6a.3.3,0,0,0,.3-.3V2.8a.3.3,0,0,0-.3-.3H2.8a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,2.8,3.7Z",
    transform: "translate(-1.12 -1.3)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_402",
    "data-name": "Trac\\xE9 402",
    d: "M2.8,8.08h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3H2.8a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,2.8,8.08Z",
    transform: "translate(-1.12 -2.877)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_403",
    "data-name": "Trac\\xE9 403",
    d: "M2.8,12.45h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3H2.8a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,2.8,12.45Z",
    transform: "translate(-1.12 -4.704)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_404",
    "data-name": "Trac\\xE9 404",
    d: "M2.8,16.83h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3H2.8a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,2.8,16.83Z",
    transform: "translate(-1.12 -6.536)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_405",
    "data-name": "Trac\\xE9 405",
    d: "M2.8,21.2h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3H2.8a.3.3,0,0,0-.3.3v.6A.3.3,0,0,0,2.8,21.2Z",
    transform: "translate(-1.12 -8.363)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_406",
    "data-name": "Trac\\xE9 406",
    d: "M12.148,2.5h-.6a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3h.6a.3.3,0,0,0,.3-.3V2.8A.3.3,0,0,0,12.148,2.5Z",
    transform: "translate(-5.041 -1.3)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_407",
    "data-name": "Trac\\xE9 407",
    d: "M12.148,6.88h-.6a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3Z",
    transform: "translate(-5.041 -2.877)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_408",
    "data-name": "Trac\\xE9 408",
    d: "M12.148,11.25h-.6a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3h.6a.3.3,0,0,0,.3-.3v-.6A.3.3,0,0,0,12.148,11.25Z",
    transform: "translate(-5.041 -4.704)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_409",
    "data-name": "Trac\\xE9 409",
    d: "M12.148,15.63h-.6a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3h.6a.3.3,0,0,0,.3-.3v-.6a.3.3,0,0,0-.3-.3Z",
    transform: "translate(-5.041 -6.536)",
    fill: "#616a7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_410",
    "data-name": "Trac\\xE9 410",
    d: "M12.148,20h-.6a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3h.6a.3.3,0,0,0,.3-.3v-.6A.3.3,0,0,0,12.148,20Z",
    transform: "translate(-5.041 -8.363)",
    fill: "#616a7d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAppartement);
export default __webpack_public_path__ + "static/media/picto_appartement.e0263091.svg";
export { ForwardRef as ReactComponent };